<template>
    <div class="client-events-page-component-container">
        <div v-if="clientEvents && clientEvents.length > 0" class="client-events-container">
            <div class="next-event-title-container">
                <p>{{ $t('your_trainings') }}</p>
            </div>
            <div class="look-ahead-trainings-text-container">
                <p>{{ $t('look_ahead_trainings', {count: clientEvents.length}) }}</p>
            </div>
            <ul class="events-list">
                <li class="event-list-wrapper" v-for="(event, index) in clientEvents" :key="index" @click="selectEvent(index)">
                    <div class="event-container" :class="[{ 'cancelled-event': event.Cancelled && !event.No_sessions_possible, 'not-reactivable-event': event.No_sessions_possible, 'selected-event': selectedEventIndex >= 0 && index == selectedEventIndex }]">
                        <div class="event-info-container">
                            <div class="event-info-wrapper" :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">
                                <div class="event-info-text-container day-name-container">
                                    <p>{{ $t(getDayMonthAndWeekday(event.Start_DateTime).dayName) }}</p>
                                </div>
                                <div class="event-info-text-container date-container">
                                    <p>{{ getDayMonthAndWeekday(event.Start_DateTime).dayNumber }} {{ $t(getDayMonthAndWeekday(event.Start_DateTime).monthName) }}</p>
                                </div>
                                <div class="event-info-text-container time-container">
                                    <p>{{ extractTimeFromDate(event.Start_DateTime) }}</p>
                                </div>
                                <div v-if="event.Cancelled || event.No_sessions_possible" class="strike-line" :class="[{ 'strike-line-cancelled-event': event.Cancelled && !event.No_sessions_possible, 'strike-line-not-reactivable-event': event.No_sessions_possible}]"></div>
                            </div>
                        </div>
                    </div>

                    <div v-if="event.Meeting_Type !== 'DUO'" class="action-btns-container">
                        <div v-if="selectedEventIndex >= 0 && index == selectedEventIndex" class="action-btns-wrapper"> <!-- :class="{'set-btn-center' : selectedEvent.Cancelled || rescheduleEventActive}" -->
                            <div class="btn-container cancel-event-btn-container" @click="showPopupMsg('confirm', 'delete')"> <!-- v-if="!selectedEvent.Cancelled" -->
                                <div class="btn cancel-btn">
                                    <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t('cancel') }}</p>
                                </div>
                            </div>
                            
                            <div class="btn-container reschedule-event-btn-container"> <!-- v-if="!rescheduleEventActive" , @click="showAvailableTimeSlotsComponent" :class="[{ 'cancelled-event': event.Cancelled, 'selected-event': selectedEventIndex >= 0 && index == selectedEventIndex }]" -->
                                <div class="btn reschedule-btn" @click="showSelectedEventPageHandle(index)" 
                                    :class="[{'disable-reschedule-btn' : maxRescheduleLimitPerMeeting >= 0 && maxRescheduleLimitPerMeeting <= Number(event.Reschedule_Count)}]"
                                >
                                    <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t('reschedule') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="action-btns-container">
                        <div v-if="selectedEventIndex >= 0 && index == selectedEventIndex && (!event.Cancelled || (event.Cancelled && IsPartnerEventActive))" class="action-btns-wrapper"> <!-- :class="{'set-btn-center' : selectedEvent.Cancelled || rescheduleEventActive}" -->
                            <div class="btn-container cancel-event-btn-container" @click="(event.Meeting_Type === 'DUO' && event.Cancelled && IsPartnerEventActive) ? showPopupMsg('confirm', 'reactivate') : showPopupMsg('confirm', 'delete')">
                                <div class="btn cancel-btn">
                                    <p v-if="event.Meeting_Type === 'DUO' && event.Cancelled && IsPartnerEventActive" :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t('reactivate') }}</p>
                                    <p v-else :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t('cancel') }}</p>
                                </div>
                            </div>
                            
                            <div class="btn-container reschedule-event-btn-container"> <!-- v-if="!rescheduleEventActive" , @click="showAvailableTimeSlotsComponent" :class="[{ 'cancelled-event': event.Cancelled, 'selected-event': selectedEventIndex >= 0 && index == selectedEventIndex }]" -->
                                <div class="btn reschedule-btn" @click="showSelectedEventPageHandle(index)" 
                                    :class="[{'disable-reschedule-btn' : maxRescheduleLimitPerMeeting >= 0 && maxRescheduleLimitPerMeeting <= Number(event.Reschedule_Count)}]"
                                >
                                    <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t('reschedule') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div v-else class="no-available-client-events-container">
            <div class="no-available-client-events-msg-container">
                <p>{{ $t('no_trainings_to_display') }}</p>
                <p>{{ $t('try_again_ask_trainer_for_help') }}</p>
            </div>
            <div class="try-again-get-client-events-btn-container" @click="reloadAppointmentPage">
                <div class="try-again-btn">
                    <img src="../../assets/icons/reload.png" alt="Try again icon">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ClientEventsPage",
    props: {
        clientEventsObj: Object,
        selectedEventIndex: Number,
        IsPartnerEventActive: Boolean,
        extractTimeFromDate: Function,
        // getDayName: Function,
        // getDayAndMonthAbbreviation: Function,
        getDayMonthAndWeekday: Function,
        showPopupMsg: Function,
        selectEvent: Function,
        showSelectedEventPageHandle: Function,


        getClientEvents: Function,
    },
    data() {
        return {
            currentDate: '',
            // selectedEventIndex: null,
            clientEvents: this.clientEventsObj.events,
            maxRescheduleLimitPerMeeting: this.clientEventsObj.maxRescheduleLimitPerMeeting,
        }
    },
    methods: {
        reloadAppointmentPage: async function () {
            await this.getClientEvents();
        },
        getCurrentDate: function() {
            const date = new Date();
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            
            const timezoneOffset = -date.getTimezoneOffset();
            const sign = timezoneOffset >= 0 ? "+" : "-";
            const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
            const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');

            this.currentDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
        },
    },
    // created() {
    //     console.log("this.clientEvents.length: " + this.clientEvents.length);
    // }
}
</script>

<style>

.client-events-page-component-container {
    position: relative;
    flex: 1;
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.client-events-page-component-container .client-events-container {
    width: 85%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    max-height: 95%;
    /* padding: 5px 0; */
    /* border: 1px solid blue; */
}

.client-events-page-component-container .next-event-title-container {
    width: 100%;
    padding-bottom: 12px;
    /* border: 1px solid red; */
}

.client-events-page-component-container .next-event-title-container p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    /* line-height: 35px; */
}

.client-events-page-component-container .events-list {
    width: 100%;
    /* flex: 1; */
    display: flex;
    flex-direction: column;
    /* justify-content: space-evenly; */
    /* border: 1px solid; */
}

.client-events-page-component-container .event-list-wrapper {
    width: 100%;
    margin-bottom: 18px;
}

.client-events-page-component-container .event-list-wrapper:last-child {
    margin-bottom: 8px;
}

.client-events-page-component-container .event-container {
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #92d400;
    border-radius: 10px;
    /* margin-bottom: 18px; */
}

.client-events-page-component-container .event-info-container {
    flex: 1;
    display: flex;
    justify-content: end;
    cursor: pointer;
    /* padding: 0 15px 0 25px; */
    /* border: 1px solid red; */
}

.client-events-page-component-container .event-info-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 4px 20px 4px 30px;
    /* border: 1px solid blue; */
}

.client-events-page-component-container .event-info-text-container {
    flex: 1;
    /* border: 1px solid blue; */
}

.client-events-page-component-container .event-info-text-container p {
    width: 100%;
    font-size: 25px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    /* border: 1px solid; */
}

.client-events-page-component-container .selected-event {
    border: 1px solid #009DF4;
}

.client-events-page-component-container .cancelled-event {
    border: 1px solid #E6E8E8;
}

.client-events-page-component-container .not-reactivable-event {
    border: 1px solid #cb061d;
}

.client-events-page-component-container .date-container {
    text-align: center;
}

.client-events-page-component-container .time-container {
    text-align: end;
    /* padding-right: 15px; */
}

.client-events-page-component-container .strike-line {
    position: absolute;
    width: calc(100% - 30px);
    top: 51%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.client-events-page-component-container .strike-line-cancelled-event {
    border: 1px solid #a0a1a3;
}

.client-events-page-component-container .strike-line-not-reactivable-event {
    border: 1px solid #cb061d;
}

.client-events-page-component-container .action-btns-container {
    width: 100%;
    display: flex;
}

.client-events-page-component-container .action-btns-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    /* border: 1px solid; */
}

.client-events-page-component-container .btn-container {
    flex: 1;
    max-width: 47%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.client-events-page-component-container .btn {
    width: 100%;
    background: #009df4;
    padding: 8px 0;
    border-radius: 30px;
    cursor: pointer;
    /* letter-spacing: 1px; */
}

.client-events-page-component-container .btn p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #ffffff;
    text-align: center;
}

.client-events-page-component-container .disable-reschedule-btn {
    background: #D6D8D8;
    pointer-events: none;
}

.client-events-page-component-container .look-ahead-trainings-text-container {
    padding: 5px 0 10px 10px;
}

.client-events-page-component-container .look-ahead-trainings-text-container p {
    font-size: 15px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    /* font-weight: bold; */
}

.client-events-page-component-container .no-available-client-events-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.client-events-page-component-container .no-available-client-events-msg-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
}

.client-events-page-component-container .no-available-client-events-msg-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    text-align: center;
    padding-bottom: 8px;
}

.client-events-page-component-container .try-again-get-client-events-btn-container {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;
    background: #009DF4;
    border-radius: 30px;
    cursor: pointer;
}

.client-events-page-component-container .try-again-btn {
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.client-events-page-component-container .try-again-btn img {
    width: 100%;
}

@media (max-width: 768px) {
    /* .client-events-container {
        justify-content: start;
    } */

    .client-events-page-component-container .no-available-client-events-msg-container p {
        font-size: calc(10px + 2.3vw);
    }

    .client-events-page-component-container .try-again-get-client-events-btn-container {
        width: 35%;
        max-width: 125px;
    }

    .client-events-page-component-container .btn {
        /* font-size: 23px; */
        padding: 7px 0;
    }
}

@media (max-width: 425px) {
    .client-events-page-component-container .strike-line {
        width: 95%;
    }

    .client-events-page-component-container .btn {
        font-size: calc(12px + 2vw);
    }

    .client-events-page-component-container .look-ahead-trainings-text-container p {
        font-size: calc(12px + 1vw);
    }

    .client-events-page-component-container .no-available-client-events-msg-container p {
        font-size: calc(10px + 2vw);
    }

    .client-events-page-component-container .try-again-get-client-events-btn-container {
        max-width: 100px;
    }

    .client-events-page-component-container .try-again-btn {
        width: 30px;
    }
}

@media (max-width: 375px) {
    .client-events-page-component-container .event-info-text-container p {
        font-size: calc(16px + 2vw);
    }

    .client-events-page-component-container .strike-line {
        width: 93%;
    }

    .client-events-page-component-container .no-available-client-events-msg-container p {
        font-size: calc(10px + 1.5vw);
    }

    .client-events-page-component-container .look-ahead-trainings-text-container p {
        font-size: calc(10px + 1vw);
    }

    .client-events-page-component-container .try-again-get-client-events-btn-container {
        max-width: 85px;
    }

    .client-events-page-component-container .try-again-btn {
        width: 25px;
    }
}

@media (max-width: 320px) {
    .client-events-page-component-container .event-info-text-container p {
        font-size: calc(16px + 1vw);
    }

    .client-events-page-component-container .strike-line {
        width: 91%;
    }

    .client-events-page-component-container .no-available-client-events-msg-container p {
        font-size: calc(10px + 1vw);
    }

    .client-events-page-component-container .try-again-get-client-events-btn-container {
        max-width: 75px;
    }

    .client-events-page-component-container .try-again-btn {
        width: 22px;
    }
}
</style>